// From https://github.com/streamich/react-use/blob/master/src/factory/createGlobalState.ts
import { Dispatch, SetStateAction, useLayoutEffect, useState } from 'react';
import { resolveHookState } from '../misc/hookState';
import useEffectOnce from '../useEffectOnce';

function createGlobalState<S>(
  initialState?: S,
): () => [S | undefined, Dispatch<SetStateAction<S>>] {
  const store: {
    state: S | undefined;
    setState: Dispatch<SetStateAction<S>>;
    setters: any[];
  } = {
    state: initialState instanceof Function ? initialState() : initialState,
    setState(nextState: SetStateAction<S>) {
      store.state = resolveHookState(nextState, store.state);
      store.setters.forEach((setter) => setter(store.state));
    },
    setters: [],
  };

  return () => {
    const [globalState, stateSetter] = useState<S | undefined>(store.state);

    useEffectOnce(() => () => {
      store.setters = store.setters.filter((setter) => setter !== stateSetter);
    });

    useLayoutEffect(() => {
      if (!store.setters.includes(stateSetter)) {
        store.setters.push(stateSetter);
      }
    }, []);

    return [globalState, store.setState];
  };
}

export default createGlobalState;
